import chesscomUrl from "@/assets/chesscom.svg";
import lichessUrl from "@/assets/lichess.svg";

// Render the provider's logo as a tiny monochrome glyph: the SVG is used as a
// CSS mask so it picks up whatever `color` we give it, regardless of the
// original brand colors baked into the file.
export function ProviderIcon({
  provider,
  size = 14,
  color = "currentColor",
  title,
}: {
  provider: string;
  size?: number;
  color?: string;
  title?: string;
}) {
  const url = provider === "chesscom" ? chesscomUrl : provider === "lichess" ? lichessUrl : null;
  if (!url) return null;
  // Human-readable provider name for the hover tooltip.
  const label = title ?? (provider === "chesscom" ? "chess.com" : provider === "lichess" ? "lichess" : provider);
  // Quote the URL: Vite inlines small SVGs as data: URIs whose brand colors
  // contain raw '#', which breaks an unquoted url(...) (the browser truncates
  // at the '#'). Quotes keep the whole data URI intact.
  const maskUrl = `url("${url}")`;
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        flexShrink: 0,
        background: color,
        WebkitMaskImage: maskUrl,
        maskImage: maskUrl,
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
    />
  );
}
